export default {"src":"/_next/static/media/GeneralSurgery.3ee1125d.svg","height":91,"width":90,"blurWidth":0,"blurHeight":0};